<template>
  <div class="fcs" :class="{ 'fcs--open': isOpen }">
    <!-- Header: clickable, shows active count when collapsed -->
    <button type="button" class="fcs__header" @click="isOpen = !isOpen">
      <span class="fcs__label">{{ label }}</span>
      <span v-if="!isOpen && selectedCount" class="fcs__active-badge">{{ selectedCount }}</span>
      <svg class="fcs__chevron" width="14" height="14" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2.5">
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </button>

    <!-- Body -->
    <div v-show="isOpen" class="fcs__body">
      <div class="fcs__chips">
        <button
          v-for="opt in visibleOptions"
          :key="opt.id"
          type="button"
          class="fcs-chip"
          :class="{
            'fcs-chip--active':   selected.includes(opt.id),
            'fcs-chip--disabled': opt.disabled && !selected.includes(opt.id),
          }"
          :disabled="opt.disabled && !selected.includes(opt.id)"
          @click="$emit('toggle', opt.id)"
        >
          {{ opt.name }}<span v-if="!selected.includes(opt.id)" class="fcs-chip__count">{{ opt.count }}</span>
        </button>
      </div>

      <!-- Show-more button -->
      <button
        v-if="options.length > initialMax"
        type="button"
        class="fcs__show-more"
        @click.stop="expanded = !expanded"
      >
        <template v-if="!expanded">
          Ещё {{ options.length - initialMax }}
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
        </template>
        <template v-else>
          Свернуть
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="18 15 12 9 6 15"/></svg>
        </template>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterChipSection',
  props: {
    label:      { type: String, required: true },
    options:    { type: Array,  default: () => [] },
    selected:   { type: Array,  default: () => [] },
    initialMax: { type: Number, default: 8 },
    defaultOpen:{ type: Boolean, default: true },
  },
  emits: ['toggle'],
  data() {
    return {
      isOpen:   this.defaultOpen,
      expanded: false,
    };
  },
  computed: {
    visibleOptions() {
      return this.expanded ? this.options : this.options.slice(0, this.initialMax);
    },
    selectedCount() {
      return this.selected.filter(id => this.options.some(o => o.id === id)).length;
    },
  },
};
</script>

<style lang="scss" scoped>
.fcs {
  border-bottom: 1px solid #f0f1f3;
  padding-bottom: 4px;

  &:last-child { border-bottom: none; }
}

.fcs__header {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  padding: 10px 0;
  background: none;
  border: none;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
}

.fcs__label {
  flex: 1;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #374151;
}

.fcs__active-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #e8192c;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

.fcs__chevron {
  flex-shrink: 0;
  color: #9ca3af;
  transition: transform 0.18s;

  .fcs--open & {
    transform: rotate(180deg);
  }
}

.fcs__body {
  padding-bottom: 12px;
}

.fcs__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.fcs-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 999px;
  border: 1.5px solid #e5e7eb;
  background: transparent;
  color: #6b7280;
  font-size: 12.5px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: border-color 0.12s, background 0.12s, color 0.12s;

  &__count {
    font-size: 11px;
    font-weight: 500;
    color: #9ca3af;
    transition: color 0.12s;
  }

  &:hover:not(:disabled) {
    border-color: #c4b5fd;
    color: #374151;
    .fcs-chip__count { color: #6b7280; }
  }

  &--active {
    border-color: #e8192c;
    background: rgba(232, 25, 44, 0.06);
    color: #e8192c;

    .fcs-chip__count { color: #e8192c; }
  }

  &--disabled {
    opacity: 0.38;
    cursor: not-allowed;
  }
}

.fcs__show-more {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 6px;
  border: none;
  background: none;
  font-family: inherit;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  cursor: pointer;
  border-radius: 6px;
  transition: background 0.12s, color 0.12s;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }
}
</style>
